import React, { useEffect, createElement } from 'react';
interface FormEmbedProps {
  formId: string;
  formName: string;
  height?: number;
  iframeId: string;
}
export function FormEmbed({
  formId,
  formName,
  height = 490,
  iframeId
}: FormEmbedProps) {
  useEffect(() => {
    // Load the script dynamically
    const script = document.createElement('script');
    script.src = 'https://docs.mindability-hypnotherapy.co.uk/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup if needed, though usually these scripts are global
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="w-full h-full min-h-[500px] bg-white rounded-2xl overflow-hidden" data-id="element-8">
      <iframe src={`https://docs.mindability-hypnotherapy.co.uk/widget/form/${formId}`} style={{
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '0px',
      minHeight: `${height}px`
    }} id={iframeId} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name={formName} data-height={height} data-layout-iframe-id={iframeId} data-form-id={formId} title={formName} data-id="element-9" />
    </div>;
}